package org.dronda.app.web.client

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.http.HttpStatusCode
import org.dronda.api.wishlist.Group

class GroupClient(private val client: HttpClient) {

    suspend fun getGroups(): Result<List<Group>, Unit> {
        val response = client.get("/wl/groups")
        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }
}
